// extracted by mini-css-extract-plugin
export default {"BuildControl":"BuildControl_BuildControl__zzH+s","Label":"BuildControl_Label__TwNru","Less":"BuildControl_Less__JTnfc","More":"BuildControl_More__yb8zC"};